import moment from 'moment';
import apiHandler from './apiHandler';

const { publicRequest, tenantRequest } = apiHandler;

function createField({ signal, body }) {

  const method = 'POST';
  return publicRequest('/telemetry/field', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function getTelemetryAttributes({
  signal, telemetry_type,
}) {

  const params = { telemetry_type };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  return tenantRequest(`/telemetry/field?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function getTypeTelemetry({ signal, edge_name: edgeName }) {

  const method = 'GET';
  return tenantRequest(`/telemetry/field?edge_name=${edgeName}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getLastValue({
  signal,
  filters,
}) {

  const {
    fields,
    deviceName,
    inverterModel,
    initDate,
    endDate,
    timeZone,
    typeTelemetry,
  } = filters;
  const url = `/telemetry/${typeTelemetry}/last-data/?device=${deviceName}${fields}&inverter=${inverterModel}&start_date=${initDate}&end_date=${endDate}&time_zone=${timeZone}&mode_value=AVG`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getTotalStatistics({
  signal,
  filters,
}) {

  const {
    initDate,
    endDate,
  } = filters;
  const url = `/telemetry/total-system-energy?start_date=${initDate}&end_date=${endDate}`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getIntervalValues({
  signal,
  filters,
}) {

  const {
    fields,
    deviceName,
    inverterModel,
    initDate,
    endDate,
    timeZone,
    typeTelemetry,
    granularity,
    modeValue,
  } = filters;

  const url = `/telemetry/${typeTelemetry}/granularity-data/?device=${deviceName}${fields}&inverter=${inverterModel}&start_date=${initDate}&end_date=${endDate}&time_zone=${timeZone}&mode_value=${modeValue}&granularity=${granularity}`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getBoxplotGraph({ filters, signal }) {

  const {
    initDate,
    endDate,
    inverter,
    device,
  } = filters;
  const url = `/telemetry/battery/charging-discharging-behavior?&start_date=${initDate}&end_date=${endDate}&inverter=${inverter}&device=${device}`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getDODGraph({ filters, signal }) {

  const {
    initDate,
    endDate,
    inverter,
    device,
  } = filters;
  const url = `/telemetry/battery/state-charge-ranges?&start_date=${initDate}&end_date=${endDate}&inverter=${inverter}&device=${device}&step=5`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceField({
  signal, device_type, skip = 0, limit = 1000,
}) {

  const method = 'GET';
  return tenantRequest(`/telemetry/field?skip=${skip}&limit=${limit}&order_by=id&device_type=${device_type}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getGranularityData({
  signal, device_type, edge_name, device, start_date, end_date, granularity,
}) {

  const star = start_date;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = end_date;

  // Convertir la cadena en un objeto Moment
  const fechaMoment = moment(end, 'YYYY-MM-DD HH:mm:ss');
  // Sumar un día a la fecha
  const fechaResultado = fechaMoment.add(1, 'days');
  // Obtener la nueva fecha en formato deseado
  const nuevaFechaString = fechaResultado.format('YYYY-MM-DD HH:mm:ss');

  const date_end = nuevaFechaString.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const endpoint = `/telemetry/generic/granularity-data/?telemetry_type=other&device_type=${device_type}${edge_name}&device=${device}&start_date=${dat_start_date}&end_date=${dat_end_date}&time_zone=%2B05&mode_value=AVG&granularity=${granularity}`;

  // console.log('getGranularityData granularity ', endpoint);

  const method = 'GET';
  return tenantRequest(endpoint, {
    reqAuth: true,
    signal,
    method,
  });

}

function getGranularityDataSum({
  signal, device_type, edge_name, device, start_date, end_date, granularity,
}) {

  const star = start_date;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = end_date;

  // Convertir la cadena en un objeto Moment
  const fechaMoment = moment(end, 'YYYY-MM-DD HH:mm:ss');
  // Sumar un día a la fecha
  const fechaResultado = fechaMoment.add(1, 'days');
  // Obtener la nueva fecha en formato deseado
  const nuevaFechaString = fechaResultado.format('YYYY-MM-DD HH:mm:ss');

  const date_end = nuevaFechaString.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const endpoint = `/telemetry/generic/granularity-data/?telemetry_type=other&device_type=${device_type}${edge_name}&device=${device}&start_date=${dat_start_date}&end_date=${dat_end_date}&time_zone=%2B05&mode_value=SUM&granularity=${granularity}`;

  // console.log('getGranularityData granularity ', endpoint);

  const method = 'GET';
  return tenantRequest(endpoint, {
    reqAuth: true,
    signal,
    method,
  });

}

function getGranularityDataDiff({
  signal, device_type, edge_name, device, start_date, end_date, granularity,
}) {

  const star = start_date;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = end_date;

  // Convertir la cadena en un objeto Moment
  const fechaMoment = moment(end, 'YYYY-MM-DD HH:mm:ss');
  // Sumar un día a la fecha
  const fechaResultado = fechaMoment.add(1, 'days');
  // Obtener la nueva fecha en formato deseado
  const nuevaFechaString = fechaResultado.format('YYYY-MM-DD HH:mm:ss');

  const date_end = nuevaFechaString.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const endpoint = `/telemetry/generic/granularity-data/?telemetry_type=other&device_type=${device_type}${edge_name}&device=${device}&start_date=${dat_start_date}&end_date=${dat_end_date}&time_zone=%2B05&mode_value=DIFF&granularity=${granularity}`;

  // console.log('getGranularityData granularity ', endpoint);

  const method = 'GET';
  return tenantRequest(endpoint, {
    reqAuth: true,
    signal,
    method,
  });

}

function getGenericLastData({
  signal,
  filters,
}) {

  const {
    deviceType,
    fields,
    deviceName,
    initDate,
    endDate,
  } = filters;

  const star = initDate;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = endDate;
  const date_end = end.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const endpoint = `/telemetry/generic/last-data/?telemetry_type=other&device_type=${deviceType}${fields}&device=${deviceName}&start_date=${dat_start_date}&end_date=${dat_end_date}&time_zone=%2B00&mode_value=AVG`;

  const method = 'GET';
  return tenantRequest(endpoint, {
    reqAuth: true,
    signal,
    method,
  });

}

function getGenericGranularityData({
  signal,
  filters,
}) {

  const {
    deviceType,
    fields,
    deviceName,
    initDate,
    endDate,
    granularity,
  } = filters;

  const star = initDate;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = endDate;
  const date_end = end.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const endpoint = `/telemetry/generic/granularity-data/?telemetry_type=other&device_type=${deviceType}${fields}&device=${deviceName}&start_date=${dat_start_date}&end_date=${dat_end_date}&time_zone=%2B00&mode_value=AVG&granularity=${granularity}`;

  const method = 'GET';
  return tenantRequest(endpoint, {
    reqAuth: true,
    signal,
    method,
  });

}

function getBoxplotGraphDevice({ filters, signal }) {

  const {
    initDate,
    endDate,
    device,
  } = filters;

  const star = initDate;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = endDate;
  const date_end = end.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const url = `/telemetry/battery/charging-discharging-behavior?&start_date=${dat_start_date}&end_date=${dat_end_date}&device=${device}`;
  const method = 'GET';
  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

function getDODGraphDevice({ filters, signal }) {

  const {
    initDate,
    endDate,
    device,
  } = filters;

  const star = initDate;
  const date_start = star.replaceAll(' ', '%20');
  const dat_start_date = date_start.replaceAll(':', '%3A');

  const end = endDate;
  const date_end = end.replaceAll(' ', '%20');
  const dat_end_date = date_end.replaceAll(':', '%3A');

  const url = `/telemetry/battery/state-charge-ranges?&start_date=${dat_start_date}&end_date=${dat_end_date}&device=${device}&step=5`;
  const method = 'GET';

  return tenantRequest(url, {
    reqAuth: true,
    signal,
    method,
  });

}

export default {
  // eslint-disable-next-line max-len
  createField,
  getTypeTelemetry,
  getTelemetryAttributes,
  getIntervalValues,
  getLastValue,
  getTotalStatistics,
  getBoxplotGraph,
  getDODGraph,
  getAllDeviceField,
  getGranularityData,
  getGranularityDataSum,
  getGranularityDataDiff,
  getGenericLastData,
  getGenericGranularityData,
  getBoxplotGraphDevice,
  getDODGraphDevice,
};
